export var USPS_VERIFICATION_ERRORS;
(function (USPS_VERIFICATION_ERRORS) {
    USPS_VERIFICATION_ERRORS["ADDRESS_NOT_FOUND"] = "This address could not be found - please enter a valid US address.";
    USPS_VERIFICATION_ERRORS["ADDRESS_IS_BUSINESS_OR_CMRA"] = "This address corresponds to either a business or a Commercial Mail Receiving Agency (CMRA), which are both not allowed for a user personal address.";
    USPS_VERIFICATION_ERRORS["ADDRESS_IS_CMRA"] = "This address corresponds to a Commercial Mail Receiving Agency (CMRA), which is not allowed.";
})(USPS_VERIFICATION_ERRORS || (USPS_VERIFICATION_ERRORS = {}));
// USPS fields mapping to our address fields
export const ADDRESS_MAPPINGS = {
    City: 'address_city',
    Address1: 'street_address',
    Address2: 'street_address',
    State: 'address_state',
    Zip5: 'zip5',
    Zip4: 'zip4'
};
